import styled from "styled-components";

export const Container = styled.div`
  span {
    display: block;
    margin-bottom: 16px;
  }
`;
